(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    (() => {
  let pending = false;
  let observedTarget;
  const desktop = window.matchMedia('(min-width: 750px)');
  const visible = element => element && element.getBoundingClientRect().width > 0 && getComputedStyle(element).visibility !== 'hidden';
  const observer = new ResizeObserver(() => schedule());
  function align() {
    pending = false;
    const main = document.getElementById('MainContent');
    const breadcrumb = main?.querySelector('.breadcrumbs');
    if (!breadcrumb) return;
    if (!desktop.matches) {
      breadcrumb.removeAttribute('data-content-aligned');
      breadcrumb.style.removeProperty('--breadcrumb-content-left');
      breadcrumb.style.removeProperty('--breadcrumb-content-width');
      return;
    }
    const selectors = ['#SlidesCon', '.materials-copy', '.shopify-policy__body', '.article-template__content', '.page-width-medium > .rte', '.page-width-narrow > .rte', '.content-cards-grid', '.collage-grid', '.product-grid', '.page-width-medium', '.page-width-narrow', '.page-width'];
    let target;
    for (const selector of selectors) {
      target = Array.from(main.querySelectorAll(selector)).find(visible);
      if (target) break;
    }
    if (!target) return;
    const box = target.getBoundingClientRect();
    const style = getComputedStyle(target);
    const leftInset = parseFloat(style.paddingLeft) + parseFloat(style.borderLeftWidth);
    const rightInset = parseFloat(style.paddingRight) + parseFloat(style.borderRightWidth);
    const mainBox = main.getBoundingClientRect();
    let left = Math.max(0, box.left + leftInset - mainBox.left);
    let width = Math.max(0, box.width - leftInset - rightInset);
    if (!document.body.classList.contains('lx-template--product') && left < mainBox.width * 0.06 && width > mainBox.width * 0.8) {
      const inset = width * 0.15;
      left += inset;
      width -= inset;
    }
    breadcrumb.style.setProperty('--breadcrumb-content-left', left.toFixed(3) + 'px');
    breadcrumb.style.setProperty('--breadcrumb-content-width', width.toFixed(3) + 'px');
    breadcrumb.setAttribute('data-content-aligned', '');
    if (target !== observedTarget) {
      observer.disconnect();
      observer.observe(target);
      observedTarget = target;
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(align);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
  document.fonts.ready.then(schedule);
})();
  } catch(e) { console.error(e); }
})();

})();
